'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $stateParams, $scope) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;

    this.firmware = {};
  }

  $onInit() {
    this.getTpFirmwares(this.$stateParams.id);
  }

  getTpFirmwares(id) {
    this.$http.get(`/api/tpFirmwares/${id}`).then(res => {
      this.firmware = res.data;
    });
  }

  update() {
    this.$http.put(`/api/tpFirmwares/${this.$stateParams.id}`, this.firmware).then(res => {
      this.$state.go('tpFirmwares');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/tpFirmwares/edit/edit.controller.js